import { render } from "./LockIcon.vue?vue&type=template&id=28ad54d0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AppSwitcherDropdown/LockIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28ad54d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28ad54d0', __exports__)) {
    api.reload('28ad54d0', __exports__)
  }
  
  module.hot.accept("./LockIcon.vue?vue&type=template&id=28ad54d0", () => {
    api.rerender('28ad54d0', render)
  })

}


export default __exports__